import { BoksPacket } from '@/protocol/_BoksPacketBase';
import { BoksOpcode } from '@/protocol/constants';

/** ⚠️ This packet is theoretical; it has never been tested in real-world conditions. */
/**
 * Command to bond with the scale.
 */
export class ScaleBondPacket extends BoksPacket {
  static readonly opcode = BoksOpcode.SCALE_BOND;
  get opcode() {
    return ScaleBondPacket.opcode;
  }
  constructor(
    public readonly data: Uint8Array,
    rawPayload?: Uint8Array
  ) {
    super(rawPayload);
  }
  static fromPayload(payload: Uint8Array): ScaleBondPacket {
    return new ScaleBondPacket(payload);
  }
  toPayload() {
    return this.data;
  }
}
